export function withoutInitialSlashes(str: string) {
  return str.replace(/^\/*/, '');
}
